<script>

import dropZone2Component from "@/components/subcomponents/dropZone2Component.vue";

export default {
  name: "commentWithTools",
  emits: ["commentPosted"],
  inject: ['$Q', '$DateTime', '$axios', '$_'],
  components: {dropZone2Component},
  props: {
    profileTS: String,
    profilePartner: String,
    textAreaPlaceholder: String,
    textAreaGuideline: String,
    commentError: Boolean,
  },
  data() {
    return {
      componentComment: {text: '', attachments: ''},
      showAttachmentBox: false,
      currentDataLoaded: false,
      commentFilesTS: '',
      commentImagesData: {
        commentAttachment_1: '',
        commentAttachment_2: '',
        commentAttachment_3: '',
        commentAttachment_4: ''
      },
    }
  },
  methods: {
    resize: function (textAreaRef) {
      let vm = this;
      let element = vm.$refs[textAreaRef];
      element.style.height = "18px";
      element.style.height = element.scrollHeight + "px";
    },
    dropZone2Emissions() {
      let vm = this;
      vm.loadCommentImages();
    },
    loadCommentImages() {
      let vm = this;
      try {
        vm.$axios
            .post('/profile/action/getCommentImages', {
              commentFilesTS: vm.commentFilesTS,
              profileTS: vm.profileTS
            }, {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${vm.currentData.token}`
              }
            })
            .then(function (response) {
              switch (response.data.success) {
                case 'true':
                  vm.commentImagesData = vm.$_.assignIn({}, vm.commentImagesData, response.data.commentImages);
                  break;
              }

              vm.$_.forEach(vm.commentImagesData, function (commentImagesDataVal) {
                if (typeof commentImagesDataVal.thumbnail !== 'undefined') {
                  vm.componentComment.attachments = vm.commentFilesTS;
                  vm.showAttachmentBox = true;
                }
              });
            })
      } catch (error) {
        console.error(error);
      }
    },
    postMyComment() {
      let vm = this;
      try {
        vm.$axios
            .post('/profile/action/postMyComment', {
              commentFilesTS: vm.commentFilesTS,
              profileTS: vm.profileTS,
              profilePartner: vm.profilePartner,
              componentComment: vm.componentComment,
              posterData: vm.currentData
            }, {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${vm.currentData.token}`
              }
            })
            .then(function (response) {
              switch (response.data.success) {
                case 'true':
                  vm.commentFilesTS = vm.$DateTime.local().setZone("UTC").toUnixInteger();
                  localStorage.setItem("commentFilesTS", vm.commentFilesTS);
                  vm.componentComment = {text: '', attachments: ''};
                  vm.commentImagesData = {
                    commentAttachment_1: '',
                    commentAttachment_2: '',
                    commentAttachment_3: '',
                    commentAttachment_4: ''
                  }
                  vm.loadCommentImages();
                  vm.$emit('commentPosted', {action: 'commentPosted'});
                  break;
              }
            });
      } catch (error) {
        console.error(error);
      }

    }
  },
  computed: {
    textareaIsEmpty() {
      let vm = this,
          isTextareaEmpty = vm.$_.trim(vm.componentComment.text) === '' && vm.$_.trim(vm.componentComment.attachments) === '';
      if (isTextareaEmpty) {
        vm.showAttachmentBox = false;
      }
      return isTextareaEmpty;
    },
    returnCommentFileTs() {
      let vm = this;
      return `${vm.profileTS}_${vm.commentFilesTS}`;
    }
  },
  mounted() {
    let vm = this;
    const storedAccount = localStorage.getItem("account");
    vm.currentData = JSON.parse(storedAccount);
    vm.currentDataLoaded = true;
    const commentFilesTSVal = localStorage.getItem("commentFilesTS");
    if (commentFilesTSVal) {
      vm.commentFilesTS = commentFilesTSVal.toString();
    } else {
      vm.commentFilesTS = vm.$DateTime.local().setZone("UTC").toUnixInteger();
      localStorage.setItem("commentFilesTS", vm.commentFilesTS);
    }
    vm.loadCommentImages();
  }
}
</script>

<template>
  <div class="columns is-mobile is-multiline is-vcentered">
    <div class="column is-full has-text-justified" v-if="textAreaGuideline.length>0">{{ textAreaGuideline }}</div>
    <div class="column is-full">
      <div class="comments-container">
         <textarea class="textarea textarea-comments" v-bind:placeholder="textAreaPlaceholder"
                   v-bind:class="{'error-input':commentError}"
                   v-on:keyup="resize('commentArea')"
                   ref="commentArea"
                   v-model.trim="componentComment.text"></textarea>
        <div class="textarea-tools">
          <div class="field has-addons">
            <p class="control">
              <button class="button is-small" v-bind:disabled="textareaIsEmpty" v-on:click="componentComment.text=''">
                <span class="icon is-small">
                  <i class="fas fa-eraser"></i>
                </span>
                <span>Clear</span>
              </button>
            </p>
            <p class="control">
              <button class="button is-small" v-on:click="showAttachmentBox= !showAttachmentBox"
                      v-bind:disabled="textareaIsEmpty">
                <span class="icon is-small">
                  <i class="fas fa-paperclip"></i>
                </span>
                <span>Attach</span>
              </button>
            </p>
            <p class="control">
              <button class="button is-small" v-bind:disabled="textareaIsEmpty" v-on:click="postMyComment">
                <span class="icon is-small">
                  <i class="fas fa-paper-plane"></i>
                </span>
                <span>Post</span>
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="column is-full" v-if="showAttachmentBox">
      <div class="columns">
        <div class="column is-one-quarter">
          <dropZone2Component
              v-bind:id="`commentAttachment_1`"
              v-bind:key="`commentAttachment_1`"
              v-bind:fileIdentifier="`commentAttachment_1`"
              v-bind:formName="`comment`"
              v-bind:zoneTitle="'Attachment 1'"
              v-bind:dataTs="returnCommentFileTs"
              v-bind:imageDataObj="commentImagesData.commentAttachment_1"
              v-bind:acceptedFiles="'image/jpeg,image/png'"
              v-on:dropZone2Emissions="dropZone2Emissions"
          ></dropZone2Component>
        </div>
        <div class="column is-one-quarter">
          <dropZone2Component
              v-bind:id="`commentAttachment_2`"
              v-bind:key="`commentAttachment_2`"
              v-bind:fileIdentifier="`commentAttachment_2`"
              v-bind:formName="`comment`"
              v-bind:zoneTitle="'Attachment 2'"
              v-bind:dataTs="returnCommentFileTs"
              v-bind:imageDataObj="commentImagesData.commentAttachment_2"
              v-bind:acceptedFiles="'image/jpeg,image/png'"
              v-on:dropZone2Emissions="dropZone2Emissions"
          ></dropZone2Component>
        </div>
        <div class="column is-one-quarter">
          <dropZone2Component
              v-bind:id="`commentAttachment_3`"
              v-bind:key="`commentAttachment_3`"
              v-bind:fileIdentifier="`commentAttachment_3`"
              v-bind:formName="`comment`"
              v-bind:zoneTitle="'Attachment 3'"
              v-bind:dataTs="returnCommentFileTs"
              v-bind:imageDataObj="commentImagesData.commentAttachment_3"
              v-bind:acceptedFiles="'image/jpeg,image/png'"
              v-on:dropZone2Emissions="dropZone2Emissions"
          ></dropZone2Component>
        </div>
        <div class="column is-one-quarter">
          <dropZone2Component
              v-bind:id="`commentAttachment_4`"
              v-bind:key="`commentAttachment_4`"
              v-bind:fileIdentifier="`commentAttachment_4`"
              v-bind:formName="`comment`"
              v-bind:zoneTitle="'Attachment 4'"
              v-bind:dataTs="returnCommentFileTs"
              v-bind:imageDataObj="commentImagesData.commentAttachment_4"
              v-bind:acceptedFiles="'image/jpeg,image/png'"
              v-on:dropZone2Emissions="dropZone2Emissions"
          ></dropZone2Component>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

.comments-container {
  position: relative;
}

.textarea-comments {
  padding-bottom: 50px !important;
}

.textarea-tools {
  position: absolute;
  bottom: 3px;
  right: 3px;
  background-color: lightgray;
  cursor: pointer;
  border: 1px solid #dbdbdb;
  border-radius: 5px;
}
</style>